// libraries.
import { useSelector } from 'react-redux';
import { DropdownButton } from '@habitech/call-to-action';

// utils.
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';
import { CountryCode } from '@domains/country';
import { AGENT_LIST_DOCUMENT } from '../../DocumentsAuditDashboard/components/DocumentsTable/utils';

interface DropdownAgentsProps {
  value: string;
  onSelectAgent: (agentId: string) => void;
}
interface Option {
  value: string;
  label: string;
}

export const DropdownAgents = ({
  onSelectAgent,
  value,
}: DropdownAgentsProps) => {
  const country = useSelector(getCountry);
  const agentValues = AGENT_LIST_DOCUMENT[country as CountryCode];

  const agentOptions: Option[] = agentValues.map(agentId => ({
    value: agentId,
    label: agentId,
  }));

  return (
    <div className="d-flex w-100">
      <DropdownButton
        dataId="agents-id"
        listOptions={agentOptions}
        placeholder="Agentes"
        value={value}
        setValue={e => {
          onSelectAgent(e as string);
        }}
        variant="white"
        size="fluid"
      />
    </div>
  );
};
